import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { DataFlowColumn } from 'app/model/dataset/dataflowcolumn';

import { ColumnExpressionProcessor } from './column-expression-processor';
import { format } from '../../shared/utils/string.util';
import { BaseSchemaModifierTransformation } from './base-schema-modifier-transformation';
import { ExpressionBasedColumnBase } from './expression-based.column.base';

@Metamodel.model({
    name: 'derive',
    display: [stringResources.DataFlowDeriveTransformationLabel, stringResources.DataFlowDeriveTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        },
        outputColumns: {
            validator: BaseSchemaModifierTransformation.validateOutputColumns
        },
        transientColumns: {
            validator: BaseSchemaModifierTransformation.validateTransientColumns
        }
    }
})
export class DeriveTransformation extends BaseSchemaModifierTransformation {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.DeriveTransformationDerivedColumn,
        constraint: {
            minOccurs: 1
        }
    })
    public expressionColumns: ExpressionBasedColumnBase[] = [];

    public get columns(): DataFlowColumn[] {
        const derivedColumns = ColumnExpressionProcessor.processNewColumns(this.expressionColumns, this.distinctInputColumnRefs, this).map((processedColumnResult) => processedColumnResult.column);
        const columns: DataFlowColumn[] = [];
        this.overwrittenColumns = [];
        this.newColumns = [];
        this.unchangedColumns = [];
        for (const column of this.inputColumns) {
            const overwrittenColumnIndex = derivedColumns.findIndex((derivedColumn) => (derivedColumn.name) === column.name);
            if (overwrittenColumnIndex > -1) {
                const overwrittenColumn = derivedColumns[overwrittenColumnIndex];
                if (columns.indexOf(overwrittenColumn) < 0) {
                    columns.push(overwrittenColumn);
                }
                if (this.overwrittenColumns.indexOf(overwrittenColumn) < 0) {
                    this.overwrittenColumns.push(overwrittenColumn);
                }
            } else {
                this.unchangedColumns.push(column);
                columns.push(column);
            }
        }

        for (const column of derivedColumns) {
            if (columns.indexOf(column) < 0) {
                columns.push(column);
                if (this.overwrittenColumns.indexOf(column) < 0) {
                    this.newColumns.push(column);
                }
            }
        }
        return columns;
    }

    public constructor() {
        super();
        this.inspectSummaryOutputFields.splice(1, 0, {
            name: () => stringResources.TransformationInspect_Update,
            icon: () => 'svg-i-9x9-Update',
            value: () => this.overwrittenColumns.length
        });
        this.inspectDetailsOutputFields.unshift({
            name: () => this.columnInfoTitle,
            icon: this._getUpdatedIcon.bind(this)
        });
    }

    protected getGeneratedDescription(): string {
        if (!!this.outputCacheId) {
            const columnNames = this.outputColumns().map((column) => column.name).filter((columnName) => !!columnName);
            if (columnNames) {
                return format(stringResources.DeriveDescription, columnNames.join(', '));
            }
        }
        return stringResources.DeriveTransformationAddColumnsDescription;
    }
}
